var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _rect3, _rect4, _path10, _path11, _polygon, _path12, _path13, _path14, _path15, _path16, _path17, _line, _path18, _rect5, _rect6, _text, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj75Mvl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 356.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aae2c2;}.cls-2{fill:#50bd86;}.cls-3{fill:#434341;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:#ffdc00;}.cls-6{font-size:35px;font-family:CloserText-Black, Closer Text;font-weight:800;letter-spacing:0.05em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.08,77.34l-40.85,2.08c-.13-1.11-.25-2.22-.38-3.33l36.83-11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.22,97.48l27,6.78c-2.3,8.73-15.12,6.28-27.64-4.58C376.79,99,377,98.21,377.22,97.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.76,57.62c3.49-16,8.66-20.55,17-15.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.85,197.82,21.62,194.1c.88,4.23.63,10.29,2.37,10.3,11.6.08,23.62-1.11,35.54-2,.68-.05,1.81-1.33,2.53-2.2A7.63,7.63,0,0,0,62.85,197.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.65,183l-22-13.69C43,179.28,53.08,186,69.65,183Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.47,48.19,145,45.31c1.19,10.23,2.31,19.92,3.44,29.62l-3.56.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.33,63.48,158.8,77.61l-1.92-2.07c5.47-5.16,10.79-10.5,16.59-15.25C174.29,59.62,177.51,61.86,181.33,63.48Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.44,82.59c3.49-6.63,11.25-6.49,21.73.34Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 274.67,
    y: 252.48,
    width: 14.12,
    height: 56.89,
    rx: 5.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.88,
    y: 261.6,
    width: 14.12,
    height: 38.65,
    rx: 5.01
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.84,245h-4.1a5,5,0,0,0-5,5v23.9H307.58V250a5,5,0,0,0-5-5h-4.09a5,5,0,0,0-5,5v61.92a5,5,0,0,0,5,5h4.09a5,5,0,0,0,5-5V288h55.15v23.9a5,5,0,0,0,5,5h4.1a5,5,0,0,0,5-5V250A5,5,0,0,0,371.84,245Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 381.51,
    y: 252.48,
    width: 14.12,
    height: 56.89,
    rx: 5.01
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 400.3,
    y: 261.6,
    width: 14.12,
    height: 38.65,
    rx: 5.01
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.65,298.75a98,98,0,1,0-98-98A98,98,0,0,0,200.65,298.75Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.65,300.68a99.92,99.92,0,1,1,100-99.92A100.07,100.07,0,0,1,200.65,300.68Zm0-196a96.05,96.05,0,1,0,96.11,96.05A96.19,96.19,0,0,0,200.65,104.71Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "308.68 120.57 283.83 118.9 281.8 93.68 317.49 57.99 319.34 83.02 344.38 84.88 308.68 120.57"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M309.43,122.56,282,120.72,279.8,93l39.3-39.31,2,27.58,27.58,2Zm-23.8-5.48,22.31,1.5L340,86.49l-22.48-1.66-1.67-22.49L283.79,94.42Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.65,278.31a77.56,77.56,0,1,0-77.6-77.55A77.57,77.57,0,0,0,200.65,278.31Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.65,254.81a54.06,54.06,0,1,0-54.09-54.05A54.07,54.07,0,0,0,200.65,254.81Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.65,256.75a56,56,0,1,1,56-56A56.07,56.07,0,0,1,200.65,256.75Zm0-108.11a52.12,52.12,0,1,0,52.15,52.12A52.19,52.19,0,0,0,200.65,148.64Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.65,227.85a27.09,27.09,0,1,0-27.11-27.09A27.1,27.1,0,0,0,200.65,227.85Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.65,229.78a29,29,0,1,1,29-29A29.07,29.07,0,0,1,200.65,229.78Zm0-54.18a25.16,25.16,0,1,0,25.18,25.16A25.19,25.19,0,0,0,200.65,175.6Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 201.28,
    y1: 200.2,
    x2: 318.57,
    y2: 82.91
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.28,202.13a1.93,1.93,0,0,1-1.37-3.3L317.2,81.54a1.93,1.93,0,0,1,2.74,2.73l-117.3,117.3A1.93,1.93,0,0,1,201.28,202.13Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 362.97,
    y: 185.36,
    width: 257,
    height: 34,
    rx: 17
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 371.97,
    y: 190.86,
    width: 195,
    height: 23,
    rx: 11.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(640.12 213.81)"
  }, "75%")), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M428.62,130.91a17.16,17.16,0,0,1,23.45,0,17.55,17.55,0,0,1,0,23.67,17.16,17.16,0,0,1-23.45,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.18,6.18,0,0,0,4.88,2.19,6.27,6.27,0,0,0,4.91-2.19,9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M477,127a13.64,13.64,0,0,1,8.6,2.54,7.94,7.94,0,0,1,3.28,6.59,8.63,8.63,0,0,1-2.52,6.12,8.49,8.49,0,0,1,3.42,6.89,8.15,8.15,0,0,1-3.35,6.74,13.85,13.85,0,0,1-8.75,2.62h-16V127Zm-5.85,8v3.83H477a2.7,2.7,0,0,0,1.8-.57,1.72,1.72,0,0,0,.68-1.37,1.67,1.67,0,0,0-.68-1.35A2.8,2.8,0,0,0,477,135Zm0,11.3v4.23h6.48a2.87,2.87,0,0,0,1.91-.59,1.93,1.93,0,0,0,.7-1.57,1.87,1.87,0,0,0-.72-1.47,2.86,2.86,0,0,0-1.89-.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M492,149.77a8.86,8.86,0,0,0,3.64.72q4.45,0,4.46-4.32V127h9.54v20.65A10.86,10.86,0,0,1,506.2,156a12.8,12.8,0,0,1-9,3.19q-3.74,0-5.13-1Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M515.56,127h24.3v8h-14.8v3.74h12.73v7.74H525.06v4.05h15.25v8H515.56Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M563,135V158.5H553.5V135H544v-8h28.48v8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.94,127h9.5v31.5h-9.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M590.62,127H601l6.93,19.21L614.69,127H625l-12.91,31.5h-8.51Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M630.85,130.91a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.15,17.15,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.18,6.18,0,0,0,4.88,2.19,6.25,6.25,0,0,0,4.9-2.19,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj75Mvl);
export default __webpack_public_path__ + "static/media/Obj_75-mvl.16015e1be8df4c125fd6a188de597b8a.svg";
export { ForwardRef as ReactComponent };